import React, { useState } from 'react'

import { Container, Button, Form, Row, Col, InputGroup } from 'react-bootstrap'
import { Modal, ModalManager, Effect } from 'react-dynamic-modal'
import { useForm } from 'react-hook-form';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { RiLoader4Line } from 'react-icons/ri';
import swal from 'sweetalert';
import axios from './../../../../services/Api'

import './index.css'

function AdminUserResetPassword({ user }) {
    const { register, errors, handleSubmit } = useForm();
    const [loading, setLoading] = useState(false)
    const [inputType, setInputType] = useState('password')

    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            overflowX: 'hidden',
            overflowY: 'auto',
            perspective: 1300,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },

        content: {
            position: 'relative',
            border: '1px solid rgba(0, 0, 0, .2)',
            width: 'inherit',
            background: '#fff',
            overflow: 'auto',
            borderRadius: '4px',
            outline: 'none',
            boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
        }
    }


    function form() {
        return (
            <>
                <Form.Group name="password" controlId="password" as={Row}>
                    <Form.Label column sm="2">
                        Nova senha *
                </Form.Label>
                    <Col sm="10">
                        <InputGroup>
                            <Form.Control
                                name="password"
                                placeholder="Informe a nova senha"
                                type={inputType}
                                ref={register({
                                    required: "Você deve informar uma senha",
                                    minLength: {
                                        value: 8,
                                        message: "A senha deve ter no mínimo 8 caracteres"
                                    },
                                    pattern: {
                                        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*/#?&])[A-Za-z\d@$!%*/#?&]{8,}$/i,
                                        message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                                    }
                                })} />

                            <InputGroup.Append>
                                <Button onClick={setPasswordView} variant="primary" className="btn-default" style={{ padding: '0px 10px', borderRadius: '0px' }}>
                                    {inputType == 'password' ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                        <span className="form-error-register">
                            {errors.password && <p>{errors.password.message}</p>}
                        </span>
                    </Col>
                </Form.Group>
            </>
        );
    }

    const setPasswordView = () => {
        setInputType((oldValue) => {
            if (oldValue == 'text')
                return 'password';
            return 'text';
        })
    }

    const reset = async (data) => {
        const { password } = data;
        try {
            setLoading(true);
            const response = await axios.post(`/api/admin/users/${user._id}/reset-password`, {
                password: password
            });
            setLoading(false);
            ModalManager.close();
            swal("Sucesso!", 'Senha resetada com sucesso!', "success");
        } catch (e) {
            setLoading(false);
            const response = e.response;
            const message = response != null ? response.data.error : e.message;
            swal("Erro!", message, "error");
        }
    }

    return (
        <div className="AdminUserResetPassword">
            <Modal
                style={style}
                effect={Effect.Fall}>
                <div className="header">
                    <div className="title">
                        Alterar senha - {user.name}
                    </div>
                </div>
                <div className="body">
                    <Container fluid>
                        <Form onSubmit={handleSubmit(reset)}>
                            {form()}
                            <div className="footer">
                                <Button varianty="primary" onClick={() => ModalManager.close()}>Cancelar</Button>
                                <Button type="submit" varianty="secondary" className="btn-secondary">
                                    {loading ?
                                        <RiLoader4Line className="spin" />
                                        :
                                        'Alterar'
                                    }
                                </Button>
                            </div>
                        </Form>
                    </Container>
                </div>
            </Modal>
        </div>
    )
}
export default AdminUserResetPassword;